module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >>> ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.navToList()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm._v(" "), _c('span', [_vm._v(" >>> ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addBtnTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(('EasyPatchLogin' == _vm.permission) || ('EasyUpdateLogin' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("Enter username(email)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Enter remark")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remake),
      expression: "remake"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.remake)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remake = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.checkInfo2), function(item, index) {
    return _c('div', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : (('FirmwareUpdateConfig' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("SN ")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceSN),
      expression: "deviceSN"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceSN = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("version (eg. 1.36.140)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version),
      expression: "version"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.version = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("model (eg. 0x7e)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.checkInfo2), function(item, index) {
    return _c('div', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : (('HCLConfig' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("SN ")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Remark")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])]) : (('HCLConfigForEasyPatch' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("Enter username(email)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.addBtnTitle))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e74eedfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/AccountAdminAdd.vue
// module id = 1503
// module chunks = 7